module.exports = __webpack_public_path__ + "static/NoPic-b1809b2c14b18c66c216e739fd0ed4bd.jpg";